var React = require('react');

function Bf (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#de0000","d":"M640 479.6H.4V0H640z","key":0}),React.createElement("path",{"fill":"#35a100","d":"M639.6 480H0V240.2h639.6z","key":1}),React.createElement("path",{"fill":"#fff300","d":"M254.6 276.2l-106-72.4h131L320 86.6 360.4 204l131-.1-106 72.4 40.5 117.3-106-72.6L214 393.4","key":2})]));
}

Bf.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Bf;

Bf.default = Bf;
